import { Error } from '@/shared/ui/error';

const PageErrorComponent = () => {
	return <Error tag="main" />;
};

export default PageErrorComponent;
